<template>
  <div>
    <!-- Step 1: Get mobile number to send code -->
    <div class="login-container" v-if="step == 1">
      <img class="logo mb-4" src="/logo.png" />
      <div class="box text-center">
        <h3 class="mx-auto mt-4 mb-1" style="font-weight: 400">
          بازیابی رمز عبور
        </h3>
        <p class="fs-xsmall grey--text">
          جهت دریافت کد بازیابی، شماره موبایل خود را وارد نمایید
        </p>
        <v-text-field
          outlined
          dense
          prepend-inner-icon="mdi-phone"
          placeholder="شماره موبایل خود را وارد کنید"
          v-model="mobile"
          color="#444"
          hide-details
          class="mb-6"
          type="number"
          @keyup.enter="mobile ? sendCode() : ''"
        ></v-text-field>
        <div class="mt-4">
          <v-btn
            class="primary"
            height="44"
            style="width: 100%"
            :loading="busy"
            :disabled="!mobile"
            @click="sendCode()"
            >تایید</v-btn
          >
        </div>
        <div class="text-center mt-6">
          <span class="link fs-small" @click="$router.push('/login')"
            >بازگشت به صفحه ورود</span
          >
        </div>
      </div>
    </div>
    <!-- Step 1: Get mobile number to send code -->
    <div class="login-container" v-if="step == 2">
      <img class="logo mb-4" src="/logo.png" />
      <div class="box text-center">
        <h5 class="mx-auto mt-4 mb-1">
          کد ارسال‌‌شده از طریق پیامک را جهت بازیابی رمز عبور وارد نمایید.
        </h5>
        <p class="fs-xsmall grey--text">
          کد تایید به شماره {{ mobile }} ارسال‌‌شده است
        </p>
        <v-text-field
          outlined
          dense
          placeholder="کد بازیابی"
          v-model="code"
          color="#444"
          hide-details
          class="mb-6"
          type="number"
        ></v-text-field>
        <v-text-field
          outlined
          dense
          placeholder="رمز عبور جدید"
          v-model="password"
          color="#444"
          hide-details
          class="mb-6"
          type="password"
        ></v-text-field>
        <v-text-field
          outlined
          dense
          placeholder="تکرار رمز عبور جدید"
          v-model="repeatPassword"
          color="#444"
          hide-details
          class="mb-6"
          type="password"
        ></v-text-field>
        <div class="text-right" v-if="computedPass">
          <v-icon class="red--text me-1" small>mdi-alert-outline</v-icon>
          <span class="red--text font-weight-bold fs-xxsmall"
            >رمز عبور جدید با تکرار آن مطابقت ندارد!</span
          >
        </div>
        <div class="mt-4">
          <v-btn
            class="primary"
            height="44"
            style="width: 100%"
            :loading="busy"
            :disabled="!code || !password || !repeatPassword || computedPass"
            @click="resetPass()"
            >تغییر رمز عبور</v-btn
          >
        </div>
        <div class="text-center mt-6">
          <span class="link fs-small" @click="step = 1"
            >ویرایش شماره موبایل</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import md5 from "js-md5";
export default {
  data() {
    return {
      mobile: "",
      busy: false,
      step: 1,
      code: "",
      password: "",
      repeatPassword: "",
    };
  },
  methods: {
    sendCode() {
      this.busy = true;
      this.$http
        .post(this.baseUrl + "/auth/getcode", {
          mobile: this.mobile,
        })
        .then((res) => {
          this.busy = false;
          if (res.status == 200) {
            this.toast(res.data, "success")
            this.step = 2;
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.busy = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    resetPass() {
      this.busy = true;
      this.$http
        .post(this.baseUrl + "/auth/resetpassword", {
          mobile:this.mobile,
          password: md5(this.password),
          confirmPassword:md5(this.repeatPassword),
          code: this.code,
        })
        .then((res) => {
          this.busy = false;
          if (res.status == 200) {
            this.toast(res.data, "success")
            this.$router.push("/login")
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.busy = false;
          this.toast("خطا: " + err.response.data, "error");
        });
      
    },
  },
  computed: {
    computedPass() {
      if (this.password && this.repeatPassword) {
        if (this.password != this.repeatPassword) {
          return true;
        } else return false;
      }
    },
  },
};
</script>

<style lang="scss"></style>
